export default __webpack_public_path__ + "folder-closed-black-shape.png";